import React from "react";
import { Provider } from "react-redux"
import { Row,Col,Container } from "react-bootstrap";
import {BrowserRouter as Router} from "react-router-dom";
import { ApolloClient, ApolloProvider, InMemoryCache,createHttpLink } from '@apollo/client';
import magazynDanych from './Magazyn'
import { setContext } from 'apollo-link-context';
import Naglowek  from "./Komponenty/naglowek";
import Strona from "./Komponenty/strona";

const uri = process.env.REACT_APP_API_URI || 'http://192.168.0.101:4001/api'
const httpLink = createHttpLink({uri})
const cache = new InMemoryCache( {resultCaching: false});

const authLink = setContext((_, {headers}) => {
  return {
    headers: {
      ...headers,
      authorization: sessionStorage.getItem('token') || '',
      //'Access-Control-Allow-Origin': ['http://192.168.0.101:4001/api','http://127.0.0.1:4001/api'],
    }
  }
})

const client = new ApolloClient({
  uri: uri,
  link: authLink.concat(httpLink),
  cache: cache,
  credentials: "include",
  resolvers: {},
  connectToDevTools: true,
})




const App = () => {
  return (
    <Provider store={magazynDanych}>
      <ApolloProvider client={client}>
        <Router>
        <link rel="stylesheet" href={"/style_nabor.css"}/>  
          <Container className="tlo_glowne" fluid> 
            <Row><Col xs={12}><Naglowek/></Col></Row>
            <Row><Strona/></Row>
          </Container>
        </Router>
      </ApolloProvider>
    </Provider>
  );
}

export default App; 